import { render } from "./CompanyBankAccountForm.vue?vue&type=template&id=2d8dc250"
import script from "./CompanyBankAccountForm.vue?vue&type=script&lang=js"
export * from "./CompanyBankAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__